import React from 'react';
import { Box, Typography } from '@mui/material';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import './styles.scss';

const Archive = () => {
  return (
    <Box className="td-archive-wrapper">
      <ArchiveOutlinedIcon sx={{ fontSize: 64, color: '#cbd5e1' }} />
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#64748b' }}>
        No Archived Items Found
      </Typography>
      <Typography variant="body2" sx={{ color: '#94a3b8', textAlign: 'center', maxWidth: 360 }}>
        Resolved entries and closed exceptions will appear here once they have been archived.
      </Typography>
    </Box>
  );
};

export default Archive;
